import axiosInstance from '../functions/axiosInstance';
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const generateNetEffectReportFromSummaryOfFindings = async (summaryOfFindingsSection = null,
    summaryOfFindingsTitle = "", summaryOfFindingsSubject, sourceFoi = null,
    resourceDictionary = null, apiToken = null) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    if (!summaryOfFindingsSection) {
        console.log("no summaryOfFindingsSection");
        return null;
    }
    if (!summaryOfFindingsTitle) {
        console.log("no summaryOfFindingsTitle");
        return null;
    }
    if (!sourceFoi) {
        console.log("no sourceFoi");
        return null;
    }
    if (!resourceDictionary) {
        console.log("no resourceDictionary");
        return null;
    }
    //console.log("CALLING SERVER with generateneteffectreportfromsummaryoffindings")
    //console.log(summaryOfFindingsSection);
    return await axiosInstance({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'generateneteffectreportfromsummaryoffindings',
            'apiToken': apiToken,
            'compositionsection': summaryOfFindingsSection,
            'compositiontitle': summaryOfFindingsTitle,
            'compositionsubject': summaryOfFindingsSubject,
            'sourcefoi': sourceFoi,
            'resourceDictionary': resourceDictionary
        },
    }).then((resp) => {
        if (resp?.data) {
            //resp.data is  { 'success': true, 'formstateid': compositionSubmissionResponse.formstateid }
            //console.log("Successful RESPONSE from generateneteffectreportfromsummaryoffindings call");
            return resp.data;
        }
        console.log("NO RESPONSE from generateneteffectreportfromsummaryoffindings call");
    }).catch((error) => { console.log(error); });
};

export default generateNetEffectReportFromSummaryOfFindings;